$(document)
  .ready(($) => {
    if ($('.js-slider-glide').length) {
      const glide = new Glide('.js-slider-glide', {
        type: 'carousel',
        peek: 230,
        perTouch: 2,
        breakpoints: {
          640: {
            peek: 0,
          },
        },
      });
      glide.mount();
    }

    if ($('.js-slider-glide-gallery').length) {
      /**
       * Update translate value by 100.
       *
       * @param  {Glide} Glide
       * @param  {Object} Components
       * @param  {EventsBus} Events
       * @return {Object}
       */
      var Example = function (Glide, Components, Events) {
        return {
          /**
           * Disables slide modification via javascript.
           *
           * @param  {Number} translate
           * @return {Number}
           */
          modify(translate) {
            return 0;
          },
        };
      };

      const glide = new Glide('.js-slider-glide-gallery', {
        type: 'carousel',
      });
      glide.mutate([Example]);
      glide.mount();
    }
  });
